import React from 'react'
export const MessageOpenIcon = () => {
  return (
    <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.589844" width="48" height="48" rx="24" fill="url(#paint0_linear_6899_34142)" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.3867 31.3796C15.3157 31.3796 13.6367 29.7006 13.6367 27.6296V18.6438C13.6367 16.5728 15.3157 14.8938 17.3867 14.8938H31.7927C33.8638 14.8938 35.5427 16.5728 35.5427 18.6438V27.6296C35.5427 29.7006 33.8638 31.3796 31.7927 31.3796H27.2289L21.3632 36.1062V33.3679V32.3191V31.3796H17.3867ZM28.971 18.8688C28.6043 18.5021 28.0096 18.5021 27.6429 18.8688L24.5898 21.9218L21.5368 18.8688C21.17 18.5021 20.5754 18.5021 20.2087 18.8688C19.8419 19.2356 19.8419 19.8302 20.2087 20.197L23.2617 23.25L20.2087 26.303C19.8419 26.6698 19.8419 27.2644 20.2087 27.6311C20.5754 27.9979 21.17 27.9979 21.5368 27.6311L24.5898 24.5781L27.6429 27.6311C28.0096 27.9979 28.6043 27.9979 28.971 27.6311C29.3378 27.2644 29.3378 26.6698 28.971 26.303L25.918 23.25L28.971 20.1969C29.3378 19.8302 29.3378 19.2356 28.971 18.8688Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6899_34142"
          x1="0.589844"
          y1="0"
          x2="55.2324"
          y2="57.2964"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E691" />
          <stop offset="1" stopColor="#0145FF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
